import { NavLink } from "react-router-dom";
import React from "react";
import classNames from "classnames";
import { UserTypes, getUserFromLocalStorage } from "@utils";
import { AccountVerificationStatus } from "@api-types/user/LoginResponseDto";

import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
type AccountVerificationItem = {
	path: string;
	translation: string;
};

export default function AccountVerificationItem(
	props: AccountVerificationItem
) {
	const { path, translation } = props;
	const rootStore = useRootAppStore();

	const getOnlineUserIfExists = rootStore.userAuthStore.isInternetUser
		? getUserFromLocalStorage(
				rootStore.userAuthStore.isPrimaryUserOnline == true
					? UserTypes.PRIMARY
					: UserTypes.SECONDARY
		  )
		: null;

	return (
		<li className="nav--tertiary__item">
			<NavLink
				to={path}
				className="nav--tertiary__link"
				activeClassName="is-active"
				isActive={(_, location) => location.pathname.includes(path)}
			>
				<span className="nav--tertiary__title">{translation}</span>
				{THEME_SETTINGS.isAccountVerificationSectionEnabled && (
					<i
						className={classNames("u-icon u-icon--sml", {
							"u-icon--alert-circle--bold u-color--sent--warning":
								getOnlineUserIfExists?.accountVerificationStatus !==
								AccountVerificationStatus.FullyVerified,
							"u-icon--check-circle--bold u-color--sent--success":
								getOnlineUserIfExists?.accountVerificationStatus ==
								AccountVerificationStatus.FullyVerified,
						})}
					/>
				)}
			</NavLink>
		</li>
	);
}
